<template>
  <div>
    <div class="headline5 mb-4">
      {{ $t(`modals.addGlobalMspPolicy.policies.cloudSecurity.title`) }}
    </div>
    <v-card class="card-wrapper">
      <v-card-text class="pa-6">
        <div class="subtitle1">{{ $t("cloudSecuritySettings.inactiveUsers") }}</div>
        <div class="text-indigo-medium">
          {{ $t("cloudSecuritySettings.inactiveUsersSubtitle") }}
        </div>
        <v-text-field
          class="mt-4 days-input"
          :label="$t('cloudSecuritySettings.numberOfDays')"
          :aria-label="$t('cloudSecuritySettings.numberOfDays')"
          :rules="[minNumber(), maxNumber(MAX_DAYS_OF_USER_INACTIVITY)]"
          v-model.number="localValue.inactiveDays"
          type="number"
          :disabled="disabled"
        ></v-text-field>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, type PropType } from "vue";
import { defaultEmptyPolicies, GlobalPolicySection } from "@/constants/msp.ts";
import cloneDeep from "lodash/cloneDeep";
import { maxNumber, minNumber } from "@/_helpers/validators.ts";
import type { GlobalPolicyConfig } from "@/_store/msp/global-policies/msp-global-policies.module.ts";

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<GlobalPolicyConfig>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:data"],
  setup(props, { emit }) {
    const MAX_DAYS_OF_USER_INACTIVITY = 365;
    const localValue = ref(
      cloneDeep(
        props.data[GlobalPolicySection.CLOUD_SECURITY] ??
          defaultEmptyPolicies[GlobalPolicySection.CLOUD_SECURITY]
      )
    );

    watch(
      localValue,
      (newVal) => {
        emit("update:data", {
          ...props.data,
          [GlobalPolicySection.CLOUD_SECURITY]: newVal,
        });
      },
      { immediate: true, deep: true }
    );

    return {
      localValue,
      MAX_DAYS_OF_USER_INACTIVITY,
      GlobalPolicySection,
      maxNumber,
      minNumber,
    };
  },
});
</script>

<style scoped lang="scss"></style>
